/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import AddToFavoritesButton from '../buttons/AddToFavorites';
import LouveIcon from '../icons/2025/MultiWolf';
import EventTitle from '../partials/EventTitle';
import Image from '../partials/Image';

import styles from '../../../styles/headers/event.module.scss';

const propTypes = {
    item: AppPropTypes.film.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const EventHeader = ({ item, className }) => {
    const { image = null, url = null } = item;
    const { url: imageUrl = null } = image || {};
    const { colors = null } = image || {};
    const [fromColor = null, toColor = null] = colors || [];
    const isEmpty = imageUrl === null;
    const randomWolf = useMemo(() => Math.floor(Math.random() * 4) + 1, []);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.noImage]: isEmpty,
                },
            ])}
            style={{
                backgroundImage: `linear-gradient(135deg, ${fromColor} 0%, ${toColor} 100%)`,
            }}
        >
            {isEmpty ? <LouveIcon className={styles.placeholder} type={randomWolf} /> : null}
            <div className={styles.inner}>
                <div className={styles.content}>
                    <div className={styles.info}>
                        <EventTitle item={item} />
                    </div>
                </div>
                <div className={styles.buttons}>
                    <AddToFavoritesButton
                        className={classNames(styles.button, styles.favoriteButton)}
                        iconClassName={styles.buttonIcon}
                        item={item}
                        loginNext={url}
                        withoutLabel
                        isDark
                    />
                </div>
            </div>
            <Image
                className={styles.backgroundPoster}
                imageClassName={styles.backgroundImg}
                media={image}
                fit
                cover
            />
        </div>
    );
};

EventHeader.propTypes = propTypes;
EventHeader.defaultProps = defaultProps;

export default EventHeader;
